module.exports = __webpack_public_path__ + "static/media/giang-portrait.bb8ffef9.jpg";